import React from 'react'
import injectSheet from 'react-jss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import WarningIcon from './WarningIcon'
import toTitle from 'helpers/accessControl/toTitle'
import { ACCESS_REVERSE_MAP, COLORS } from 'helpers/globals'
import tippy from 'tippy.js'

class LimitTable extends React.Component {
  componentDidMount = _ => tippy(`.${this.props.classes.helpIcon}`, { duration: 0, theme: 'topbar', placement: 'bottom', onShow: instance => this.tooltip = instance })

  componentWillUnmount = _ => this.tooltip && this.tooltip.hide()

  render() {
    const { selectedModel, addingExpansion, usages, classes } = this.props

    return (
      <table className={classes.table} cellSpacing='0'>
        <thead>
          <tr>
            <th>Device Type</th>
            <th>{ selectedModel.allows_expansion ? 'Direct Limit' : 'Limit' }</th>
            { selectedModel.allows_expansion &&
              <th>
                Total Limit
                <a className={classes.helpIcon} title='Total limit across main controller and all expansion controllers'>
                  <FontAwesomeIcon icon='info-circle' />
                </a>
              </th>
            }
          </tr>
        </thead>
        <tbody>
          { ['doors', ...Object.keys(ACCESS_REVERSE_MAP)].map(limitType =>
              <tr key={limitType}>
                <td>{toTitle(limitType)}</td>
                { !addingExpansion && usages[limitType] > selectedModel.limits[limitType]
                  ? <td className='limit'>
                      {selectedModel.limits[limitType]}
                      <WarningIcon title={`This controller currently has ${usages[limitType]} ${toTitle(limitType)}, but ${selectedModel.model} only supports ${selectedModel.limits[limitType]} ${toTitle(limitType)}`} />
                    </td>
                  : <td>{selectedModel.limits[limitType]}</td>
                }
                { selectedModel.allows_expansion && <td>{selectedModel.total_limits[limitType]}</td> }
              </tr>
            )
          }
        </tbody>
      </table>
    )
  }
}

const style = {
  table: {
    width: 'auto',
    margin: '0 1rem 1rem 1rem',
    '& th': {
      padding: '1px',
      fontWeight: 500,
      '&:not(:first-of-type)': { textAlign: 'right' }
    },
    '& td': {
      padding: '.5rem 1rem .5rem .5rem',
      border: 'none',
      '&:not(:first-of-type)': { textAlign: 'right' },
      '&.limit': { color: 'red' }
    },
    '& > tbody > tr': {
      '&:nth-child(even)': {
        background: COLORS.tertiary
      }
    }
  },
  helpIcon: {
    marginLeft: '.5rem'
  }
}

export default (injectSheet(style)(LimitTable))



// WEBPACK FOOTER //
// ./src/components/DoorControllerModelSelector/ModelDetails/LimitTable.js